import React from 'react';
import TermlyEmbed from './TermlyEmbed';

const PrivacyPolicy = () => {
  return <TermlyEmbed dataId="13d638fb-9167-4a7b-8b68-eb366e975d10" />;
};

export default PrivacyPolicy;
